import React from 'react';


const HeroSection = ({ onStartQuiz }) => {
  const archetypes = [
  { name: 'Performer', description: 'Achievement-driven, validation-seeking' },
  { name: 'Ghost', description: 'Emotionally withdrawn, invisible' },
  { name: 'Controller', description: 'Dominant, authority-seeking' },
  { name: 'Pleaser', description: 'People-focused, approval-seeking' },
  { name: 'Destroyer', description: 'Self-sabotaging, rebellious' }];


  return (
    <div className="w-full max-w-5xl mx-auto px-4 md:px-6 lg:px-8">
      <div className="text-center space-y-8 md:space-y-10">
        {/* Main Headline */}
        <div className="space-y-6">
          <p className="text-sm md:text-base text-brand-gold uppercase tracking-wider font-semibold">
            For High-Achievers Who Keep Stalling on What Actually Matters
          </p>
          <h1 className="md:text-5xl lg:text-6xl font-bold text-brand-white uppercase tracking-tight text-[32px]">
            Discover the Hidden Identity Pattern That's Secretly Keeping You Stuck
          </h1>
          <p className="text-xl md:text-2xl text-brand-steel max-w-3xl mx-auto leading-relaxed">You're not lazy. You're not broken. You're operating from a hidden identity—formed in childhood for survival—that treats your ambitions like threats. Psychologists call it the False Self. This quiz reveals which of the 5 False Self patterns is working against you.

          </p>
        </div>

        {/* CTA Button */}
        <div className="pt-6">
          <button
            onClick={onStartQuiz}
            className="w-full md:w-auto min-w-[320px] bg-brand-gold hover:bg-brand-gold/90 text-brand-black font-bold text-lg md:text-xl px-10 md:px-12 py-5 md:py-6 rounded-md transition-all duration-250 hover:transform hover:-translate-y-0.5 active:scale-[0.97] uppercase tracking-wide">

            Start Assessment
          </button>
          <p className="text-sm md:text-base text-brand-steel mt-4">Free • 2 minutes • Instant results

          </p>
        </div>

        {/* Description */}
        <div className="bg-brand-charcoal rounded-lg p-8 md:p-10 lg:p-12 border border-brand-slate">
          <div className="space-y-4 text-base md:text-lg text-brand-steel">
            <p className="leading-relaxed">
              Through 25 targeted questions, you'll discover your dominant pattern and the internal conflict driving your behavior. No motivational clichés. No surface-level advice. Just the mechanism.
            </p>
            <p className="leading-relaxed">
              Takes 2 minutes. Results are instant.
            </p>
          </div>
        </div>
      </div>
    </div>);

};

export default HeroSection;